<template>
    <footer class="footer has-cards">
        <div class="container container-lg estatisticas-site">
            <div class="row">
                <div class="col-6 col-lg-3 text-center" v-if="totalMembros !== null">
                    <icon name="fa fa-group" type="default" size="lg" rounded class="mb-1">
                    </icon>
                    <h3 class="display-1 mb-1">{{totalMembros}}</h3>
                    <h4 class="mb-4 font-weight-light">usuários registrados</h4>
                </div>
                <div class="col-6 col-lg-3 text-center" v-if="totalTitulos !== null">
                    <icon name="fa fa-film" type="default" size="lg" rounded class="mb-1">
                    </icon>
                    <h3 class="display-1 mb-1">{{totalTitulos}}</h3>
                    <h4 class="mb-4 font-weight-light">títulos cadastrados</h4>
                </div>
                <div class="col-6 col-lg-3 text-center" v-if="totalMidias !== null">
                    <icon name="fa fa-volume-up" type="default" size="lg" rounded class="mb-1">
                    </icon>
                    <h3 class="display-1 mb-1">{{totalMidias}}</h3>
                    <h4 class="mb-4 font-weight-light">dublagens disponíveis</h4>
                </div>
                <div class="col-6 col-lg-3 text-center" v-if="totalTrocas !== null">
                    <icon name="ni ni-bag-17" type="default" size="lg" rounded class="mb-1">
                    </icon>
                    <h3 class="display-1 mb-1">{{totalTrocas}}</h3>
                    <h4 class="mb-4 font-weight-light">trocas realizadas</h4>
                </div>
            </div>
        </div>
        <div class="container mt-2">
            <hr>
            <div class="row align-items-center">
                <div class="col-12">
                    <div class="copyright text-center">
                        <p class="h6 mb-0">Sessão da Tarde &mdash; desde 2002 preservando a memória da dublagem brasileira</p>
                        <small class="text-muted">Esse site não apoia a pirataria nem a divulgação de qualquer tipo de material audiovisual que esteja sob copyright.</small>
                    </div>
                </div>
            </div>
        </div>
    </footer>
</template>
<script>
export default {
  name: 'app-footer',
  computed: {
    totalMembros() {
        return this.$store.state.catalog.total_membros;
    },
    totalTitulos() {
        return this.$store.state.catalog.total_titulos;
    },
    totalMidias() {
        return this.$store.state.catalog.total_midias;
    },
    totalTrocas() {
        return this.$store.state.catalog.total_trocas;
    }
  }
};
</script>
<style>
@media (max-width: 768px){
    .estatisticas-site h3 {
        font-size: 2em;
    }
    .estatisticas-site h4 {
        font-size: 1.2em;
    }

    .copyright {
        max-width: 70%;
        margin: 0 auto; 
    }

    .copyright .h6 {
        margin-bottom: .75em !important;
    }
}
.footer .copyright .h6 {
    font-weight: 600;
}
</style>
